import { render, staticRenderFns } from "./career.vue?vue&type=template&id=5c4885a2"
import script from "./career.vue?vue&type=script&lang=ts"
export * from "./career.vue?vue&type=script&lang=ts"
import style0 from "./career.vue?vue&type=style&index=0&id=5c4885a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports